
import collect from 'collect.js'
import mapboxgl from 'mapbox-gl'
import MapboxLanguage from '@mapbox/mapbox-gl-language'
// import List from '@/assets/icons/fontawesome/light/list.svg?inline'
import Times from '@/assets/icons/fontawesome/light/times.svg?inline'
import FilterIcon from '@/assets/icons/fontawesome/light/filter.svg?inline'

export default {
  components: {
    // List,
    Times,
    FilterIcon,
  },
  props: {
    aggregator: {
      type: String,
      default: null,
    },
    place: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default() {
        return {
          sort: 'desc',
          sort_by: 'popular',
        }
      },
    },
    results: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      map: {},
      card: null,
      popups: [],
      popup: null,
      cardId: null,
      popupId: null,
      focused: null,
      showList: false,
      showFilters: false,
      initialized: false,
    }
  },
  head() {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v2.4.1/mapbox-gl.css',
        },
      ],
    }
  },
  watch: {
    results(newResults, oldResults) {
      if (newResults !== oldResults && Object.keys(this.map).length > 0) {
        this.$nextTick(() => {
          this.mapMarkers()
        })
      }
    },
    show(value) {
      if (value) {
        this.$nextTick(() => {
          if (!this.initialized) {
            this.mapInit()
          }
        })

        document.querySelector('body').classList.add('overflow-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-hidden')
      }
    },
    priceDisplay(value) {
      this.mapMarkers()
    },
    colorMode(value) {
      if (this.initialized) {
        this.map.setStyle(
          value === 'dark'
            ? 'mapbox://styles/mapbox/dark-v10'
            : 'mapbox://styles/mapbox/streets-v11',
        )
      }
    },
    popupId(value) {
      if (value) {
        this.$nextTick(() => {
          this.popup = collect(this.results).first((item) => {
            return parseInt(item.hotel_id) === parseInt(value)
          })
        })
      }
    },
    cardId(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.card = collect(this.results).first((item) => {
            return parseInt(item.hotel_id) === parseInt(newValue)
          })
        })

        this.active(document.getElementById(newValue))
      }

      this.unactive(document.getElementById(oldValue))
    },
  },
  mounted() {
    mapboxgl.accessToken = this.$config.mapboxglAccessToken

    if (!['loaded', 'deferred'].includes(mapboxgl.getRTLTextPluginStatus())) {
      mapboxgl.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        null,
        true,
      )
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close()
      }
    })
  },
  methods: {
    mapInit() {
      this.initialized = true
      this.map = new mapboxgl.Map({
        container: 'map',
        style:
          this.colorMode === 'dark'
            ? 'mapbox://styles/mapbox/dark-v10'
            : 'mapbox://styles/mapbox/streets-v11',
        center: [this.place._geoloc.lng, this.place._geoloc.lat],
        // bounds: [this.place.geometry.viewport.southwest, this.place.geometry.viewport.northeast],
        zoom: 12,
        maxPitch: 0,
        attributionControl: false,
      })
      this.map.addControl(new mapboxgl.NavigationControl())
      this.map.addControl(
        new mapboxgl.FullscreenControl({
          container: document.querySelector('#map'),
        }),
      )
      this.map.addControl(
        new MapboxLanguage({
          defaultLanguage: 'mul',
        }),
      )
      this.map.on('load', () => {
        this.mapMarkers()
      })
      this.map.on('dragstart', () => {
        // this.card = null
        // this.popup = null
        this.cardId = null
        this.popupId = null
        this.focused = null
        // this.showList = false
        // this.showFilters = false
      })
      this.map.on('dragend', () => {
        this.$emit('load-map', { center: this.map.getCenter() })
      })
    },
    mapMarkers() {
      const properties = {
        type: 'FeatureCollection',
        features: collect(this.results)
          .map((item) => {
            return {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [item.geoloc.lon, item.geoloc.lat],
              },
              data: {
                id: item.hotel_id,
                title: item.name,
                price: this.formatMoney(
                  Number(item.client_price.amount_with_markup),
                  item.client_price.currency,
                  this.$i18n.locale,
                  true,
                ),
                url: this.url(item),
              },
            }
          })
          .all(),
      }
      properties.features.forEach((property, index) => {
        const current = this.popups[index]
        if (typeof current !== 'undefined') {
          current
            .setLngLat(property.geometry.coordinates)
            .setHTML(
              `<span class='property' id="${property.data.id}">${property.data.price}</span>`,
            )
        } else {
          const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
          })
            .setLngLat(property.geometry.coordinates)
            .setHTML(
              `<span class='property' id="${property.data.id}">${property.data.price}</span>`,
            )
            .addTo(this.map)

          this.popups.push(popup)
        }
      })
      Array.from(document.getElementsByClassName('property')).forEach(
        (marker) => {
          marker.addEventListener(
            'mouseenter',
            (event) => {
              this.popupId = event.target.id
              this.$nextTick(() => {
                const x = event.clientX + 'px'
                const y = event.clientY + 10 + 'px'
                const hoverPopup = document.getElementById('popup')
                if (hoverPopup !== null) {
                  if (this.dir === 'rtl') {
                    const clientWidth =
                      document.getElementById('map').clientWidth
                    hoverPopup.style.right = clientWidth - event.clientX + 'px'
                  } else {
                    hoverPopup.style.left = x
                  }
                  hoverPopup.style.top = y
                }
              })
            },
            false,
          )
          marker.addEventListener(
            'mouseleave',
            (event) => {
              this.$nextTick(() => {
                this.popupId = null
              })
            },
            false,
          )
          marker.addEventListener(
            'click',
            (event) => {
              this.$nextTick(() => {
                this.cardId = event.target.id
                this.focused = event.target.id
                // this.active(document.getElementById(event.target.id))
              })
            },
            false,
          )
        },
      )
    },
    url(data) {
      if (data.hotel.aggregator === 'innstant') {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
          params: {
            countrySlug: data.hotel_path.split('/')[0],
            destinationSlug: data.hotel_path.split('/')[1],
            hotelSlug: data.hotel.slug,
          },
          query: this.search || this.searchQuery,
        })
      } else {
        return this.localePath({
          name: 'hotels-place-countrySlug-hotelId',
          params: {
            countrySlug: data.hotel.country.slug,
            hotelId: data.hotel.id,
          },
          query: this.search || this.searchQuery,
        })
      }
    },
    enter(result) {
      this.cardId = null
      this.popupId = null
      this.map.flyTo({
        center: [result.geoloc.lon, result.geoloc.lat],
        zoom: 15,
      })
      // new mapboxgl.Popup({
      //   closeButton: false,
      //   closeOnClick: false
      // }).setLngLat([result.geoloc.lon, result.geoloc.lat])
      //   .setHTML('<h3 class="text-xl">' + result.name + '</h3>')
      //   .addTo(this.map)
      this.active(document.getElementById(result.hotel_id))
    },
    leave(result) {
      // const popUps = Array.from(document.getElementsByClassName('mapboxgl-popup'))
      // if (popUps[0]) {
      //   popUps[0].remove()
      // }
      this.unactive(document.getElementById(result.hotel_id))
    },
    active(element) {
      if (element && element.parentElement) {
        element.parentElement.parentElement.classList.add('z-10')
        element.parentElement.classList.add(
          '!bg-[color:var(--brand-light)]',
          '!dark:bg-[color:var(--brand-dark)]',
          '!text-[color:var(--bg-brand-alt-light)]',
          '!dark:text-[color:var(--bg-brand-alt-dark)]',
        )
      }
    },
    unactive(element) {
      if (element && element.parentElement) {
        element.parentElement.parentElement.classList.remove('z-10')
        element.parentElement.classList.remove(
          '!bg-[color:var(--brand-light)]',
          '!dark:bg-[color:var(--brand-dark)]',
          '!text-[color:var(--bg-brand-alt-light)]',
          '!dark:text-[color:var(--bg-brand-alt-dark)]',
        )
      }
    },
    swipeList(direction) {
      if (screen.width > 639) {
        return
      }
      if (direction === 'right' && this.dir === 'ltr') {
        this.showList = false
      }
      if (direction === 'left' && this.dir === 'rtl') {
        this.showList = false
      }
    },
    swipeFilters(direction) {
      if (screen.width > 639) {
        return
      }
      if (direction === 'left' && this.dir === 'ltr') {
        this.showFilters = false
      }
      if (direction === 'right' && this.dir === 'rtl') {
        this.showFilters = false
      }
    },
    loadMore() {
      if (this.show) {
        this.$emit('load-more')
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
